var map = {
	"./banking/calendar.svg": 1280,
	"./banking/credit.svg": 1281,
	"./banking/current.svg": 1282,
	"./banking/graduate-account.svg": 1283,
	"./banking/loot.svg": 1284,
	"./banking/personal-loans.svg": 1285,
	"./banking/prepaid.svg": 1286,
	"./banking/savings.svg": 1287,
	"./banking/senior-account.svg": 1288,
	"./banking/standard-account.svg": 1289,
	"./banking/student-account.svg": 1290,
	"./brand/facebook.svg": 579,
	"./brand/instagram.svg": 580,
	"./brand/linkedin.svg": 581,
	"./brand/tiktok.svg": 582,
	"./brand/twitter.svg": 583,
	"./brand/youtube.svg": 584,
	"./broadband/broadband.svg": 1291,
	"./energy/bolt.svg": 1292,
	"./energy/business.svg": 1293,
	"./energy/energy.svg": 1294,
	"./energy/gas.svg": 1295,
	"./energy/lamp.svg": 1296,
	"./generic/Stars.svg": 1166,
	"./generic/badge.svg": 1297,
	"./generic/devices.svg": 1298,
	"./generic/discount-tag.svg": 1299,
	"./generic/globe.svg": 1300,
	"./generic/hands-heart.svg": 1301,
	"./generic/newspaper.svg": 1302,
	"./generic/person-headest.svg": 1303,
	"./generic/radio-tower.svg": 1304,
	"./generic/review.svg": 1225,
	"./generic/speech.svg": 1305,
	"./generic/star.svg": 1249,
	"./generic/thumbs.svg": 1306,
	"./generic/woman-headset.svg": 1307,
	"./insurance/car.svg": 1308,
	"./insurance/health.svg": 1309,
	"./insurance/home.svg": 1310,
	"./insurance/income.svg": 1311,
	"./insurance/life.svg": 1312,
	"./insurance/mort-prot.svg": 1313,
	"./insurance/serious-ill.svg": 1314,
	"./mortgage/block.svg": 1315,
	"./mortgage/house.svg": 1316,
	"./mortgage/key.svg": 1317,
	"./mortgage/lifetimeHouse.svg": 1318,
	"./mortgage/mortgage.svg": 1319
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1167;